import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-data-foundations }}\n{{outlet}}",{ moduleName: "embercom/templates/apps/app/users/segments.hbs" })